import { createSlice } from "@reduxjs/toolkit";
import { ReleaseDto } from "../actions/customerReleaseSignatureAction";
import {
  getAllReleasesAction,
  createReleaseAction,
  updateReleaseAction,
} from "../actions/customerReleaseSignatureAction";

interface ReleaseState {
  releases: ReleaseDto[];
  getAllLoading: boolean;
  getAllError: string | null;

  createLoading: boolean;
  createError: string | null;

  updateLoading: boolean;
  updateError: string | null;
}

const initialState: ReleaseState = {
  releases: [],
  getAllLoading: false,
  getAllError: null,

  createLoading: false,
  createError: null,

  updateLoading: false,
  updateError: null,
};

const releaseSlice = createSlice({
  name: "release",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllReleasesAction.pending, (state) => {
        state.getAllLoading = true;
        state.getAllError = null;
      })
      .addCase(getAllReleasesAction.fulfilled, (state, action) => {
        state.getAllLoading = false;
        state.releases = action.payload?.body ?? [];
      })
      .addCase(getAllReleasesAction.rejected, (state, action) => {
        state.getAllLoading = false;
        state.getAllError = (action.payload as any)?.message ?? "Failed";
      });

    builder
      .addCase(createReleaseAction.pending, (state) => {
        state.createLoading = true;
        state.createError = null;
      })
      .addCase(createReleaseAction.fulfilled, (state) => {
        state.createLoading = false;
      })
      .addCase(createReleaseAction.rejected, (state, action) => {
        state.createLoading = false;
        state.createError = (action.payload as any)?.message ?? "Failed";
      });

    builder
      .addCase(updateReleaseAction.pending, (state) => {
        state.updateLoading = true;
        state.updateError = null;
      })
      .addCase(updateReleaseAction.fulfilled, (state) => {
        state.updateLoading = false;
      })
      .addCase(updateReleaseAction.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateError = (action.payload as any)?.message ?? "Failed";
      });
  },
});

export default releaseSlice.reducer;
